import React from 'react';
import SEO from '../src/components/seo';
import RedirectToApp from '../src/components/redirect';
import { t } from '@lingui/macro';
import { Trans } from '@lingui/react';
import Layout from '~/components/layout/_layout';

class Redirect extends React.Component {

    componentDidMount() {
        new RedirectToApp(window.navigator.userAgent);
    }

    render() {
        return (
            <Layout>
                <SEO
                    title={t`personal.download_app.headline`}
                    noIndex={true}
                />

                <h1>
                    <Trans id="personal.download_app.headline" />
                </h1>

                <div style={{
                    textAlign: 'center',
                    margin: '35px 0',
                }}>
                    <Trans id="personal.download_app.message" />
                </div>

            </Layout>
        );
    }
}

export default Redirect;
